class EstateContent {

    content: string;

    static fromJson(json: any): EstateContent {
        const estate: EstateContent = new EstateContent();
        estate.content = json.content;
        return estate;
    }

}

export default EstateContent;